const newsletter = {
  Title: "Your trusted source for supplement education",
  Description:
    "Subscribe to our monthly newsletter, The Script, specifically designed to help practitioners stay current with the latest developments in the supplement industry.",
  Subscribe: "Subscribe now",
  Error: "Unable to subscribe, please try again later",
};

export { newsletter };
